import { differenceInSeconds } from '@fs/zion-locale/date-fns'
import { splunk } from '@fs/zion-splunk-logger'
import { getSameTypeTasks } from './checkForSameTypeSpam'
import getCollectionIds from './getCollectionIds'

// Splunk logging for frequency spam (repeated fast pressing of the same button within a specific time interval)
export const logFrequencySpam = (type, cisId, collectionIds, spamDuration, totalButtonPressCount) => {
  const logObject = {
    cisId,
    collectionIds,
    message: `${type} frequency spamming on quick name review`,
    spamDurationInSeconds: spamDuration,
    totalButtonPressCount,
  }
  splunk.log(logObject)
}

// Get the most recent same-type tasks that all happened within the last {interval}
const getTasksPerInterval = (taskCache, interval, type) => {
  const sameTypeTasks = getSameTypeTasks(taskCache, type)
  const now = Date.now()

  return [
    ...(sameTypeTasks?.filter((task) => {
      return differenceInSeconds(now, task.timestamp) <= interval
    }) || []),
  ]
}

export default function checkForFrequencySpam({
  cisId,
  count,
  frequencySpamData,
  interval,
  taskCache,
  setFrequencySpamData,
  type,
}) {
  const { isFrequencySpamming: isSpamming } = frequencySpamData

  // No point checking for spam if there aren't enough completed tasks yet
  if (taskCache.current?.length < count) return

  const mostRecentTask = taskCache.current?.slice(-1)?.[0]
  const intervalTasks = getTasksPerInterval(taskCache, interval, type)

  // If the user wasn't spamming, but now has started
  const frequencySpammingStarted = isSpamming === false && intervalTasks.length === count
  const spamStartIndex = taskCache.current?.length || 0 - count

  if (frequencySpammingStarted) {
    setFrequencySpamData({
      isFrequencySpamming: true,
      spamStartTime: taskCache.current[spamStartIndex].timestamp,
      spamStartIndex: taskCache.current?.length || 0 - count,
    })
  }

  // If the user was spamming, but now has stopped
  const frequencySpammingStopped = isSpamming === true && intervalTasks.length < count

  if (frequencySpammingStopped) {
    const spamDuration = differenceInSeconds(mostRecentTask.timestamp, frequencySpamData.spamStartTime)
    const totalButtonPressCount = taskCache.current?.length || 0 - frequencySpamData.spamStartIndex

    getCollectionIds(taskCache.current)
      .then((collectionIds) => {
        logFrequencySpam(mostRecentTask.actionType, cisId, collectionIds, spamDuration, totalButtonPressCount)
      })
      .catch((error) => console.error('Error logging garbage spam:', error))

    taskCache.current = []

    setFrequencySpamData({
      isFrequencySpamming: false,
      spamStartTime: null,
      spamStartIndex: null,
    })
  }
}
